export default __webpack_public_path__ + "static/media/fireFN25.3dfb4451.svg";